import React from 'react';
export function Footer() {
  return <footer className="bg-white py-16" data-id="element-81" data-mp="32wd0e9mw79qd">
      <div className="mx-auto max-w-4xl px-6 text-center" data-id="element-82" data-mp="3gf94uw0pu68y">
        <p className="font-display text-2xl text-mint-700" data-id="element-83" data-mp="3ggtxuh7dth4p">
          MegaPack Salud Plena
        </p>
        <p className="mx-auto mt-4 max-w-2xl text-[15px] leading-relaxed text-ink-soft" data-id="element-84" data-mp="32pp6s3i2xx5z">
          El sistema de reparación intestinal más completo para personas que comen
          "sano" pero siguen inflamadas. De España a México. De Colombia a Chile.
          De Guatemala a Argentina. Diseñado para que transformes tu inflamación
          en 15 días sin dietas restrictivas, sin confusión y sin culpa.
        </p>
        <p className="mx-auto mt-4 max-w-xl text-[15px] text-ink-muted" data-id="element-85" data-mp="3lgop4lv2k8qa">
          Porque tener un intestino saludable no debería costarte años de
          búsqueda. En ningún país del mundo.
        </p>

        <div className="mt-10 border-t border-mint-200 pt-8 text-sm text-ink-muted" data-id="element-86" data-mp="2a1ji55nwno0v">
          <p data-id="element-87" data-mp="2ew716p053q82">© NATURIA — Tu camino hacia la salud integral. Todos los derechos reservados.</p>
          <p className="mt-2" data-id="element-88" data-mp="3lbmt1p3mp2eb">
            <a href="https://www.naturiasalud.com" className="text-mint-700 underline-offset-4 hover:underline" data-id="element-89" data-mp="3gapb9dmj6adc">
              intestino.naturiasalud.com
            </a>
            <span className="mx-2" aria-hidden="true" data-id="element-90" data-mp="3v5n7ihksvjzp">
              ·
            </span>
            <a href="mailto:naturiaintestinal@gmail.com" className="text-mint-700 underline-offset-4 hover:underline" data-id="element-91" data-mp="3q7bxa5qlf7gy">
              soporte.int@naturiasalud.com
            </a>
          </p>
          <p className="mx-auto mt-6 max-w-2xl text-xs leading-relaxed" data-id="element-92" data-mp="33e4p5rpsiq3">
            Los precios están expresados en euros (€). El
            cobro se procesa automáticamente en la moneda local de tu país al
            momento del pago. Este material es educativo e informativo y no
            reemplaza el diagnóstico ni el tratamiento médico profesional.
          </p>
        </div>
      </div>
    </footer>;
}